import { Injectable } from '@angular/core';
import { BaseService, Resource } from '@app/core/services/base.service';
import { HttpClient } from '@angular/common/http';
import { ResourceType } from '@dwo/enums';
import { Observable } from 'rxjs';
import { SiteDto } from '@admin/models/site-dto';
import { LocationAdministrationControllerService } from '@app/generated/api/locationAdministrationController.service';

@Injectable({
  providedIn: 'root',
})
export class SiteService extends BaseService {
  constructor(
    private locationController: LocationAdministrationControllerService,
    http: HttpClient,
  ) {
    super(http);
  }

  @Resource(ResourceType.LoadSites)
  loadSites(): Observable<SiteDto[]> {
    return this.locationController.getSites() as Observable<SiteDto[]>;
  }

  @Resource(ResourceType.AddSite)
  addSite(site: SiteDto): Observable<void> {
    return this.locationController.createSite(site);
  }

  @Resource(ResourceType.GetSite)
  getSite(siteId: string): Observable<SiteDto> {
    return this.locationController.getSite(siteId) as Observable<SiteDto>;
  }

  @Resource(ResourceType.UpdateSite)
  updateSite(site: SiteDto): Observable<void> {
    return this.locationController.updateSite(site.id, site);
  }
}
